import classNames from 'classnames';
import { render, unmount } from 'rc-util/lib/React/render';
import React, { useEffect, useRef, useState } from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import CommonModal from '@/ComUI/commonModal';
import message from '@/ComUI/message';
import { useConfig } from '@/configProvider';
import { IResponseTeamCreate } from '@/types';
import { changeIdentity } from '..';
import Button from '../../ComUI/button';
import { TypeTrack } from '../identitySwitch/shared';
import { createTeam } from '../utils';
import './index.less';

const BannerImage =
    'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/create-modal-banner.png';

export interface CreateTeamModalProps {
    /** 创建团队完后, 是否切换身份, 默认为切换 */
    noSwitchIdentity?: boolean;
    /** 创建团队成功的entrance埋点参数 */
    create_team_success_entrance?: string;
    // 来自哪个具体的项目
    project?: string;
    onCreatedComplete?: (data: IResponseTeamCreate) => void;
    onClose?: () => void;
    onTrack?: TypeTrack;
}

interface CreateTeamModalComponent extends React.FC<CreateTeamModalProps> {
    open: (props: CreateTeamModalProps) => void;
}

const CreateTeamModal: CreateTeamModalComponent = ({
    project = '',
    noSwitchIdentity,
    create_team_success_entrance,
    onCreatedComplete,
    onClose,
    onTrack,
}) => {
    const { userInfo } = useConfig();
    const inputRef = useRef<any>();

    const [teamName, setTeamName] = useState('');
    const isPending = useRef(false);

    const maxTeamNameLength = 21;

    useEffect(() => {
        setTeamName('');
        inputRef.current?.focus();
    }, []);

    useEffect(() => {
        if (!userInfo.screen_name) return;
        setTeamName(`${userInfo.screen_name}的团队`);
    }, [userInfo.screen_name]);

    console.log(create_team_success_entrance, 'CreateTeamModal======', project);

    const createHandle = () => {
        if (!teamName) {
            return message.error('请填写完整团队信息');
        }
        if (teamName.length >= maxTeamNameLength) {
            return message.error('请填输入20字内的团队/企业名称');
        }
        if (isPending.current) return;
        isPending.current = true;

        createTeam({
            teamName,
        })
            .then((res) => {
                onTrack?.('create_team_success', {
                    entrance: create_team_success_entrance ?? 'create_team_1',
                    project,
                    team_name: teamName,
                    newcreate_oid: res.oid,
                    newcreate_uid: res.ouid,
                });
                onCreatedComplete?.({
                    group_id: res.groupId,
                    oid: res.oid,
                    ouid: res.ouid,
                    team_name: res.teamName,
                });
                message.success('创建成功');
                // 会员弹窗关闭时回调函数
                onClose?.();
                if (!noSwitchIdentity) {
                    changeIdentity({
                        ouid: res.ouid,
                        oid: res.oid,
                        groupId: res.groupId,
                    });
                }
            })
            .finally(() => {
                isPending.current = false;
                console.log('create team finally');
            });
    };

    return (
        <CommonModal open destroyOnClose className="Widget teamSpaceCreateModal">
            <div className="teamSpaceCreateModal-inner">
                <div className="close" onClick={onClose}>
                    <IconFont fontSize={14} name="CrossBlack" color="var(--content-system-tertiary)" />
                </div>

                <div className="teamSpaceCreateModal-banner">
                    <img src={BannerImage} alt="" />
                </div>

                <div className="teamSpaceCreateModal-form">
                    <div className="teamSpaceCreateModal-formTitle">创建团队</div>
                    <div className="teamSpaceCreateModal-formLabel">团队名称</div>
                    <div
                        className={classNames('teamSpaceCreateModal-input', {
                            warn: teamName.length >= maxTeamNameLength,
                        })}
                    >
                        <input
                            value={teamName}
                            ref={inputRef}
                            placeholder="请输入团队名称"
                            type="text"
                            maxLength={maxTeamNameLength}
                            onChange={(e: any) => {
                                setTeamName(e.target.value);
                            }}
                        />
                    </div>
                    <Button
                        type="primary"
                        style={{ marginTop: 32, height: 48, fontSize: 16 }}
                        onClick={() => {
                            createHandle();
                        }}
                    >
                        免费创建
                    </Button>
                    <p className="teamSpaceCreateModal-renameTip">团队名称可随时修改</p>
                </div>
            </div>
        </CommonModal>
    );
};

CreateTeamModal.displayName = 'CreateTeamModal';

let el: HTMLDivElement | null = null;

CreateTeamModal.open = ({ onClose, ...restProps }: CreateTeamModalProps) => {
    if (!el) {
        el = document.createElement('div');
    }
    document.body.appendChild(el);

    render(
        <CreateTeamModal
            {...restProps}
            onClose={() => {
                if (el && el.parentNode) {
                    unmount(el);
                    el.parentNode.removeChild(el);
                    el = null;
                }
                onClose?.();
            }}
        />,
        el,
    );
};

export const openCreateTeamModal = CreateTeamModal.open;
